<template>
  <div class="upload-file">
    <el-upload
      multiple
      :action="uploadFileUrl"
      :before-upload="handleBeforeUpload"
      :file-list="fileList"
      :limit="limit"
      :on-error="handleUploadError"
      :on-exceed="handleExceed"
      :on-success="handleUploadSuccess"
      :show-file-list="false"
      :headers="headers"
      :http-request="handleUploadForm"
      class="upload-file-uploader"
      ref="fileUpload">
      <!-- 上传按钮 新增disabled状态绑定-->
      <el-button :disabled="isSignUp" size="mini" type="primary"
        >选取文件</el-button
      >

      <!-- 上传提示 -->
      <!-- <div class="el-upload__tip" slot="tip" v-if="showTip">
        请上传
        <template v-if="fileSize">
          大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b>
        </template>
        <template v-if="fileType">
          格式为 <b style="color: #f56c6c">{{ fileType.join('/') }}</b>
        </template>
        的文件
      </div> -->
      <div class="el-upload__tip" slot="tip" v-if="showTip">
        <template>
          <b style="margin-top: 0">最多{{ limit }}个文件</b>
        </template>
      </div>
    </el-upload>

    <!-- 文件列表 -->
    <transition-group
      class="upload-file-list el-upload-list el-upload-list--text"
      name="el-fade-in-linear"
      tag="ul">
      <li
        :key="file.url"
        class="el-upload-list__item ele-upload-list__item-content"
        v-for="(file, index) in fileList">
        <!--   :href="`${baseUrl}${file.url}`" -->
        <el-link :href="`${file.url}`" :underline="false" target="_blank">
          <!-- {{ getFileName(file.name) }} -->
          <span class="el-icon-document"> {{ file.fileName }} </span>
        </el-link>
        <!-- <div class="ele-upload-list__item-content-action">
          <el-link
            :underline="false"
            @click="handleDelete(index, file)"
            type="danger"
            >删除</el-link
          >
        </div> -->
      </li>
    </transition-group>
  </div>
</template>

<script>
import { getToken } from '@/utils/auth';
import { uploadFile } from '@/api/file';

export default {
  name: 'FileUpload',
  props: {
    // 值
    value: [String, Object, Array],
    // 数量限制
    limit: {
      type: Number,
      default: 5,
    },
    // 大小限制(MB)
    fileSize: {
      type: Number,
      default: 5,
    },
    // 文件类型, 例如['png', 'jpg', 'jpeg']
    fileType: {
      type: Array,
      default: () => ['doc', 'xls', 'ppt', 'txt', 'pdf'],
    },
    // 是否显示提示
    isShowTip: {
      type: Boolean,
      default: true,
    },
    fileUrl: {
      type: String,
      default: '/file/upload',
    },
    informationId: {
      type: String,
    },
    examId: {
      type: String,
    },
    isSignUp: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      number: 0,
      uploadList: [],
      baseUrl: process.env.VUE_APP_BASE_API,
      // uploadFileUrl: process.env.VUE_APP_BASE_API + "/common/upload", // 上传文件服务器地址
      // :action="upload.url + '?updateSupport=' + upload.updateSupport"
      uploadFileUrl:
        process.env.VUE_APP_BASE_API +
        this.fileUrl +
        '?informationId=' +
        this.informationId, // 上传文件服务器地址
      headers: {
        Authorization: 'Bearer ' + getToken(),
      },
      fileList: [],
      registrationNumber: [],
      regisNumberChoose: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          let temp = 1;
          // 首先将值转为数组
          const list = Array.isArray(val) ? val : this.value.split(',');
          // 然后将数组转为对象数组
          this.fileList = list.map((item) => {
            if (typeof item === 'string') {
              item = { name: item, url: item };
            }
            item.uid = item.uid || new Date().getTime() + temp++;
            return item;
          });
          console.log(this.fileList, 'this.fileList======');
        } else {
          this.fileList = [];
          return [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    console.log(this.$route.params, '2222------');
    if (localStorage.getItem('regisNumberChoose')) {
      this.regisNumberChoose = JSON.parse(
        localStorage.getItem('regisNumberChoose')
      );
    }
    if (localStorage.getItem('registrationNumber')) {
      this.registrationNumber = JSON.parse(
        localStorage.getItem('registrationNumber')
      );
    }
  },
  computed: {
    // 是否显示提示
    showTip() {
      return this.isShowTip && (this.fileType || this.fileSize);
    },
  },
  methods: {
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件类型
      if (this.fileType) {
        const fileName = file.name.split('.');
        const fileExt = fileName[fileName.length - 1];
        const isTypeOk = this.fileType.indexOf(fileExt) >= 0;
        if (!isTypeOk) {
          this.$message.error(
            `文件格式不正确，请上传${this.fileType.join('/')}格式文件!`
          );
          return false;
        }
      }
      // 校检文件名是否包含特殊字符
      if (file.name.includes(',')) {
        this.$message.error('文件名不正确，不能包含英文逗号!');
        return false;
      }
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      // this.$modal.loading('正在上传文件，请稍候...');
      this.number++;
      return true;
    },
    // 文件个数超出
    handleExceed() {
      this.$message.error(`上传文件数量不能超过 ${this.limit} 个!`);
    },
    // 上传失败
    handleUploadError(err) {
      this.$message.error('上传文件失败，请重试');
      // this.$modal.closeLoading();
    },
    // 上传成功回调
    handleUploadSuccess(res, file) {
      console.log(res, 'res222222==============');
      if (res.code === 200) {
        // this.uploadList.push({ name: res.fileName, url: res.fileName });
        this.uploadList.push({
          name: res.data.originalFilename,
          url: res.data.url,
        });
        this.uploadedSuccessfully();
      } else {
        this.number--;
        // this.$modal.closeLoading();
        this.$message.error(res.msg);
        this.$refs.fileUpload.handleRemove(file);
        this.uploadedSuccessfully();
      }
    },
    // 删除文件
    handleDelete(index, item) {
      this.fileList.splice(index, 1);
      // this.$emit('input', this.listToString(this.fileList));
      this.$emit('change', this.fileList);
      this.$emit('delete', item);
    },
    // 上传结束处理
    uploadedSuccessfully() {
      if (this.number > 0 && this.uploadList.length === this.number) {
        this.fileList = this.fileList.concat(this.uploadList);
        this.uploadList = [];
        this.number = 0;
        // this.$emit('input', this.listToString(this.fileList));
        // this.$modal.closeLoading();
        this.$emit('change', this.fileList);
      }
    },
    // 获取文件名称
    getFileName(name) {
      // 如果是url那么取最后的名字 如果不是直接返回
      if (name.lastIndexOf('/') > -1) {
        return name.slice(name.lastIndexOf('/') + 1);
      } else {
        return name;
      }
    },
    // 对象转成指定字符串分隔
    listToString(list, separator) {
      let strs = '';
      separator = separator || ',';
      for (let i in list) {
        strs += list[i].url + separator;
      }
      return strs != '' ? strs.substr(0, strs.length - 1) : '';
    },

    // 上传
    handleUploadForm(param) {
      console.log(param, 'param======');
      if (!param.file || typeof param.file !== 'object' || !param.file.name) {
        console.error('Invalid file object:', param.file);
        return;
      }
      const formData = new FormData();
      if (!this.registrationNumber || this.registrationNumber.length == 0)
        return;
      const data = {
        informationId: this.informationId,
        registrationNumber: this.regisNumberChoose
          ? this.regisNumberChoose
          : this.registrationNumber[this.registrationNumber.length - 1],
      };
      formData.append('files', param.file);
      const loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      console.log(formData, 'formData====');
      uploadFile(formData, data)
        .then((res) => {
          console.log(res, 'res4444====');
          loading.close();
          this.$message.success('上传成功');
          res.data.map((item) => {
            this.fileList.push({
              name: item.originalFileName,
              url: item.url,
              fileName: item.fileName,
              originalFileName: item.originalFileName,
              fileId: item.fileId,
              informationId: this.informationId,
            });
          });
          this.$emit('change', this.fileList);
        })
        .catch((res) => {
          loading.close();
        });
    },
  },
};
</script>

<style scoped lang="scss">
.upload-file-uploader {
  margin-bottom: 5px;
}
.upload-file-list .el-upload-list__item {
  border: 1px solid #e4e7ed;
  line-height: 2;
  margin-bottom: 10px;
  position: relative;
}
.upload-file-list .ele-upload-list__item-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
}
.ele-upload-list__item-content-action .el-link {
  margin-right: 10px;
}
</style>
